import { PaymentPeriod } from '@base/backend';

export const PaymentPeriodTranslations = {
  getTypeTranslation(paymentPeriod: PaymentPeriod) {
    switch (paymentPeriod) {
      case PaymentPeriod.Yearly:
        return 'jährlich';

      case PaymentPeriod.Halfyearly:
        return 'halbjährlich';

      case PaymentPeriod.Quarterly:
        return 'vierteljährlich';

      case PaymentPeriod.Monthly:
        return 'monatlich';

      default:
        return '';
    }
  }
};
